import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_FACILITY_HOLIDAY, UPDATE_FACILITY_HOLIDAY_SUCCESS, UPDATE_FACILITY_HOLIDAY_ERROR } from '../../actions';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateFacilityHoliday({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { holidayId, ...data } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/facility-holiday/${holidayId}`,
      method: 'PUT',
      data,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: UPDATE_FACILITY_HOLIDAY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_FACILITY_HOLIDAY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_FACILITY_HOLIDAY_ERROR, payload: error });
  }
}

export function* watchUpdateFacilityHoliday() {
  yield takeEvery(UPDATE_FACILITY_HOLIDAY, updateFacilityHoliday);
}

function* updateFacilityHolidaySaga() {
  yield all([fork(watchUpdateFacilityHoliday)]);
}

export default updateFacilityHolidaySaga;
